import { useAppContext } from '../../../Services/AppContext';
import { MetaKey } from '../../Meta/Enums/MetaKey.enum';
import useWorkplaceMeta from '../../Workplace/Hooks/useWorkplaceMeta';
import useUserMeta from '../../User/Hooks/useUserMeta';
import { useMemo } from 'react';

export default function useElectronicSignature() {
	const { userData, workplaceId } = useAppContext();
	const { workplaceMeta, isLoadingWorkplaceMeta } = useWorkplaceMeta({
		workplaceId,
	});
	const { userMeta, isLoadingUserMeta } = useUserMeta({ userId: userData.id });

	const isQualifiedCertificateForElectronicSignatureUsed =
		userMeta[MetaKey.USE_QUALIFIED_CERTIFICATE_FOR_ELECTRONIC_SIGNATURE] ??
		false;

	const isPasswordRequiredForElectronicSignatureUsed =
		userMeta[MetaKey.REQUIRE_PASSWORD_FOR_ELECTRONIC_SIGNATURE] ?? false;

	const isElectronicSignatureTimestampAllowed =
		workplaceMeta[MetaKey.USE_ELECTRONIC_SIGNATURE_TIMESTAMP] ?? false;

	const formFieldDefaultValues = useMemo(() => {
		return {
			electronicSignature: isQualifiedCertificateForElectronicSignatureUsed,
			electronicSignatureTimestamp:
				isQualifiedCertificateForElectronicSignatureUsed &&
				isElectronicSignatureTimestampAllowed,
		};
	}, [
		isQualifiedCertificateForElectronicSignatureUsed,
		isElectronicSignatureTimestampAllowed,
	]);

	return {
		isQualifiedCertificateForElectronicSignatureUsed,
		isPasswordRequiredForElectronicSignatureUsed,
		isElectronicSignatureTimestampAllowed,
		formFieldDefaultValues,
		isLoading: isLoadingWorkplaceMeta || isLoadingUserMeta,
	};
}
